import { render, staticRenderFns } from "./baoxiuMy.vue?vue&type=template&id=04f6462a&scoped=true"
import script from "./baoxiuMy.vue?vue&type=script&lang=js"
export * from "./baoxiuMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f6462a",
  null
  
)

export default component.exports